import React from 'react';

/**
 * Standard Section Wrapper component for consistent spacing and backgrounds
 * Background options: white, light (#F7FBFA), cream (#FFFFFF), dark (#2A8C8E), primary
 * Padding options: sm, md, lg, xl
 */
const Section = ({
  children,
  background = 'white',
  padding = 'lg',
  maxWidth = 1280,
  panel,
  className = '',
  style,
  ...props
}) => {
  const backgrounds = {
    white: 'var(--cream-canvas)',
    light: 'var(--surface-soft-1)',
    cream: 'var(--cream-canvas)',
    dark: 'var(--brand-green-darker)',
    primary: 'var(--brand-green-deep)',
  };

  const textClasses = {
    white: 'text-[var(--text-primary)]',
    light: 'text-[var(--text-primary)]',
    cream: 'text-[var(--text-primary)]',
    dark: 'text-white',
    primary: 'text-white',
  };
  
  const paddings = {
    sm: 'py-8 md:py-12',
    md: 'py-12 md:py-16',
    lg: 'py-16 md:py-20',
    xl: 'py-20 md:py-32',
  };
  
  const usePanel = panel ?? ['white', 'light', 'cream'].includes(background);

  return (
    <section
      className={`${textClasses[background]} ${paddings[padding]} ${className}`}
      style={{ backgroundColor: backgrounds[background], ...style }}
      {...props}
    >
      <div 
        className="container mx-auto px-4 sm:px-6 lg:px-8"
        style={{ maxWidth: `${maxWidth}px` }}
      >
        {usePanel ? <div className="mhdf-floating-panel">{children}</div> : children}
      </div>
    </section>
  );
};

export default Section;
